﻿<script>
	import { fade } from "svelte/transition";
</script>

<section in:fade={{ duration: 500 }} out:fade={{ duration: 0 }}>
	<slot></slot>
</section>
